
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface ExistingApplicationCardProps {
  onCancel: () => void;
}

const ExistingApplicationCard: React.FC<ExistingApplicationCardProps> = ({ onCancel }) => {
  return (
    <div className="container mx-auto px-4 py-8">
      <Card className="max-w-2xl mx-auto">
        <CardHeader>
          <CardTitle>Application Already Submitted</CardTitle>
          <CardDescription>
            You already have a startup application in our system. Please check your application status on the main page.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button onClick={onCancel}>
            Back to Dashboard
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default ExistingApplicationCard;
